import { useTheme } from "app/shared";
import { FC } from "react";

import styles from "./Traction.module.scss";

interface Metric {
  label: string;
  value: string;
}

interface TractionProps {
  data: Metric[];
  isTokenMetrics?: boolean;
  isKeyMetrics?: boolean;
}

const Traction: FC<TractionProps> = ({
  data,
  isTokenMetrics,
  isKeyMetrics,
}) => {
  const { theme } = useTheme();

  const metrics = data.filter((metric) => metric.value?.trim() !== "");

  if (metrics.length === 0) return null;

  let title;
  if (!isTokenMetrics && !isKeyMetrics) {
    title = <h2 className={styles.title}>Traction</h2>;
  } else {
    title = (
      <h2 className={styles.titleSecond}>
        {isTokenMetrics ? "Token Metrics" : "Round Details"}
      </h2>
    );
  }

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      {title}
      <div className={styles.metricsGrid}>
        {metrics.map((metric, index) => (
          <div
            key={index}
            className={`${styles.metricCard} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            {(isTokenMetrics || isKeyMetrics) && (
              <div className={styles.metricLabel}>{metric.label}</div>
            )}
            <div className={styles.metricValue}>{metric.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Traction;
